import { Copy06Icon } from '@/components/icons/Copy06Icon';
import { Copy07Icon } from '@/components/icons/Copy07Icon';
import { Download01Icon } from '@/components/icons/Download01Icon';
import { File02Icon } from '@/components/icons/File02Icon';
import { LinkExternal01Icon } from '@/components/icons/LinkExternal01Icon';
import { DeleteMenuItemWithConfirmationModal } from '@/components/poppers/MenuPopper/DeleteMenuItemWithConfirmationModal';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
interface MemoContextMenuItemsProps {
  braintrustLogsUrl?: string;
  onExportMemoToPdf: () => void;
  onExportMemoToWord: () => void;
  onCopyMemoToClipboard: () => void;
  onDuplicateMemo?: () => void;
  onDeleteMemo: () => void;
  deletingMemo?: boolean;
  copyingMemo?: boolean;
  duplicatingMemo?: boolean;
  disableNonDeleteActions?: boolean;
  disableDeleteMemo?: boolean;
  showDeleteMemo?: boolean;
}

export function MemoContextMenuItems({
  braintrustLogsUrl,
  onExportMemoToPdf,
  onExportMemoToWord,
  onCopyMemoToClipboard,
  onDuplicateMemo,
  onDeleteMemo,
  deletingMemo = false,
  copyingMemo = false,
  duplicatingMemo = false,
  disableNonDeleteActions = false,
  disableDeleteMemo = false,
  showDeleteMemo = true,
}: MemoContextMenuItemsProps) {
  const showDuplicateMemo = !!onDuplicateMemo;

  return (
    <>
      <MenuItem
        icon={<Download01Icon size={16} />}
        label="Export to PDF"
        onClick={onExportMemoToPdf}
        disabled={disableNonDeleteActions}
      />
      <MenuItem
        icon={<File02Icon size={16} />}
        label="Export to Word"
        onClick={onExportMemoToWord}
        disabled={disableNonDeleteActions}
      />
      <MenuItem
        icon={<Copy06Icon size={16} />}
        label="Copy to clipboard"
        onClick={onCopyMemoToClipboard}
        loading={copyingMemo}
        disabled={disableNonDeleteActions}
        muiMenuItemProps={{
          divider:
            !showDuplicateMemo && (!!braintrustLogsUrl || showDeleteMemo),
        }}
      />
      {showDuplicateMemo && (
        <MenuItem
          icon={<Copy07Icon size={16} />}
          label="Duplicate memo"
          onClick={onDuplicateMemo}
          loading={duplicatingMemo}
          disabled={disableNonDeleteActions}
          muiMenuItemProps={{ divider: !!braintrustLogsUrl || showDeleteMemo }}
        />
      )}
      {braintrustLogsUrl && (
        <MenuItem
          icon={<LinkExternal01Icon size={16} />}
          label="View Braintrust logs"
          onClick={() =>
            window.open(braintrustLogsUrl, '_blank', 'noopener,noreferrer')
          }
          disabled={disableNonDeleteActions}
          muiMenuItemProps={{
            divider: showDeleteMemo,
          }}
        />
      )}
      {showDeleteMemo && (
        <DeleteMenuItemWithConfirmationModal
          label="Delete memo"
          onConfirmDelete={onDeleteMemo}
          menuItemProps={{
            loading: deletingMemo,
            disabled: disableDeleteMemo,
          }}
          modalProps={{
            heading: 'Are you sure you want to delete this memo?',
          }}
        />
      )}
    </>
  );
}
